import React, {useEffect, useState} from 'react'
import {Center, FileInput, FileInputProps, Group} from '@mantine/core';
import {IconPhoto, IconUpload} from '@tabler/icons';
import {Simulate} from "react-dom/test-utils";


interface IFileProps {
  setFile: (file: File[] | null) => void
  file: File[] | null
  error?: string | null
  required?: boolean
  disabled?: boolean
  acceptFileType?: FileInputProps['accept']
}

function UseFileInput({setFile, file, error, required = false, disabled = false,acceptFileType}: IFileProps) {
  const [totalSize, setTotalSize] = useState<number>(0);
  const [sizeValid, setSizeValid] = useState<boolean>(true);

  useEffect(() => {
    if (totalSize > 5e+7) {
      setSizeValid(false);
    } else if (totalSize < 5e+7 && totalSize > 0) {
      setSizeValid(true);
    }
  }, [totalSize])

  return (
    <FileInput placeholder="Загрузить файл" icon={<IconUpload size={14}/>} multiple
               accept={acceptFileType}
               valueComponent={() => ValueComponent && file ? ValueComponent({value: file ?? null}) : null}
               required={required}
               onChange={(e) => {
                 if (e) {
                   let size = 0
                   let dt = new DataTransfer();
                   e.forEach(i => {
                     dt.items.add(i)
                     size = size + i.size;
                   })
                   setTotalSize(size);
                   setFile(e)
                 } else if (!e) {
                   setTotalSize(0);
                 }
               }}
               value={file ?? undefined}
               error={
                 !!error ? error :
                   !sizeValid && "Файл(ы) превышают допустимый размер в 50mb"}
               disabled={disabled}
               defaultValue={file ?? undefined}
    />
  )
}

function Value({file}: { file: File | null }) {
  return (
    <Center
      inline
      sx={(theme) => ({
        backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[7] : theme.colors.gray[3],
        fontSize: theme.fontSizes.xs,
        padding: '3px 7px',
        borderRadius: theme.radius.sm,
        display: 'flex',
      })}
    >
      <IconPhoto size={14} style={{marginRight: 5}}/>
      <span
        style={{
          whiteSpace: 'nowrap',
          textOverflow: 'ellipsis',
          overflow: 'hidden',
          maxWidth: 160,
          display: 'inline-block',
        }}
      >
        {file?.name}
      </span>
    </Center>
  );
}

const ValueComponent: FileInputProps['valueComponent'] = ({value}) => {
  if (Array.isArray(value)) {
    return (
      <Group spacing="xs" py="xs" sx={{padding: "0!important"}}>
        {value.map((file, index) => (
          <Value file={file} key={index}/>
        ))}
      </Group>
    );
  }

  return <Value file={value}/>;
};

export default UseFileInput